
module.exports = {
    MONGO_URL: "mongodb+srv://minh16082002:Minh16082002@cluster0.ja2yq.mongodb.net/SIC-DB",
    API_URL: 'https://sicdb.vercel.app'
}

